import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { FocusSkuUploadSheet } from '@/components/DataVault/upload/FocusSkuUploadSheet'
import { ManageFocusedSkusPage } from '@/components/FocusedSkus/ManageFocusedSkusPage'
import {
  manageSearchSchema,
  withoutManageDefaults,
  type ManageSearch,
} from '@/components/FocusedSkus/manageSearch'

/** Wiring only. The schema lives beside the page in `manageSearch.ts`. */
export const Route = createFileRoute('/_app/focused-data/manage-skus/')({
  validateSearch: manageSearchSchema,
  component: ManageSkusRoute,
})

function ManageSkusRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<ManageSearch>) =>
      void navigate({
        search: (current) => withoutManageDefaults({ ...current, ...next }),
        replace: true,
      }),
    [navigate],
  )
  // Composed here: the upload sheet is the Data Vault's, the page Focused SKUs'.
  return (
    <ManageFocusedSkusPage
      search={search}
      onSearchChange={onSearchChange}
      uploadSheet={(props) => <FocusSkuUploadSheet {...props} />}
    />
  )
}
